import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import Badge from '../Badge/Badge';
import Input from '../Input/Input';
import Text from '../Text/Text';
import toggleArrayItem from '../../helpers/toggleArrayItem';

const TagsInput = ({
  tags, onTagsChange, tagType, maxTagsCount
}) => {
  const [tagText, setTagText] = useState('');
  const [tempTags, setTempTags] = useState(tags || []);
  const onTagClose = (text) => setTempTags(toggleArrayItem(tempTags, text));

  const onChange = (text) => {
    let arr = tempTags;
    if (text.includes(',')) {
      text.split(',')
        ?.map((i) => {
          if (i) {
            arr = toggleArrayItem(arr, i, false);
          }
          return true;
        });
      setTempTags(arr.slice(0, maxTagsCount));
      setTagText('');
    } else {
      setTagText(text);
    }
  };

  useEffect(() => {
    onTagsChange(tempTags);
  }, [tempTags]);

  return (
    <div>
      <div className="customScroll border border-[#E1E3EA] dark:border-[#1b263b]
        py-[5px] px-[13px] rounded-[5px] my-[12px] flex flex-row items-baseline
        flex-wrap max-h-[400px] overflow-auto"
      >
        {!!tempTags.length && tempTags?.map((text) => (
          <Badge
            key={text}
            text={text}
            onClose={() => onTagClose(text)}
            containerStyle="mr-[5px] mb-[5px]"
            type={tagType}
          />
        ))}
        {(maxTagsCount > tempTags.length)
        && (
        <Input
          type="text"
          name="tag_text"
          value={tagText}
          onChange={({ target: { value } }) => onChange(value)}
          inputStyle="px-[4px] py-0 bg-transparent border-none max-w-[70px] focus:bg-transparent"
          autocomplete={false}
        />
        )}
      </div>
      <Text
        textStyle="text-[11px]"
        muted
        text={'Separate the ids by adding a comma ,'
          + ` between each id. Max : ${maxTagsCount}`}
      />
    </div>
  );
};

TagsInput.propTypes = {
  tags: PropTypes.arrayOf(PropTypes.string),
  onTagsChange: PropTypes.func,
  tagType: PropTypes.string,
  maxTagsCount: PropTypes.number
};

TagsInput.defaultProps = {
  tags: [],
  onTagsChange: () => {},
  tagType: undefined,
  maxTagsCount: 1000
};

export default TagsInput;
